import colors from "./colors";
import fonts from "./font";

export const color = colors;
export const font = fonts;
